import React from 'react'
import { Button } from 'react-bootstrap'
import { cancelEditing } from '../services';
import { ButtonLoader } from '../_components/Loader';

const ButtonComp = ({ id, submitFunc, type, endPoint, variant, isDisable = false, isViewOnly = false, CallCancelEdit = true }) => {

    const cancelEdit = async () => {
        if (id && type === "Cancel" && CallCancelEdit) {
            let data = await cancelEditing(`${endPoint}/cancelEditing/${id}`);
            if (data?.status === 200) {
                submitFunc();
            } else {
                submitFunc();
            }
        } else {
            submitFunc();
        }
    };

    return (
        <div>
            {isDisable ?
                <Button>
                    <ButtonLoader />
                </Button> :
                isViewOnly ?
                    null
                    :
                    <Button
                        variant={variant}
                        onClick={() => id
                            ? cancelEdit()
                            : submitFunc()}
                    >
                        {type}
                    </Button>
            }
        </div>
    )
}

export default ButtonComp
